<template>
  <q-dialog v-model="openSync" @hide="$emit('update:user', null)">
    <q-card style="width: 45rem; max-width: 80vw">
      <q-card-section tag="section">
        <h5 class="text-capitalize">{{ user.type }} Information</h5>
      </q-card-section>

      <q-card-section tag="section">
        <div class="row q-col-gutter-sm">
          <div class="col-12 col-sm-6 flex items-center">
            <p class="text-muted q-mr-md">Company Logo:</p>
            <q-avatar size="4rem">
              <img alt="user avatar" :src="userPhoto" />
            </q-avatar>
          </div>

          <div class="col-12 col-sm-6">
            <p class="text-muted">Registered account ID:</p>
            <p>
              {{ user.type === 'shipper' ? user.id : user.company.id }}
            </p>
          </div>
        </div>
      </q-card-section>

      <q-card-section v-if="isTransporter" tag="section">
        <div class="bg-gray q-pa-md">
          <div class="row q-col-gutter-sm">
            <div class="col-12 col-sm-6">
              <p class="text-muted q-mb-xs">Port of Operation:</p>
              <p class="q-mb-none">{{ user.company.operationCity.name }}</p>
            </div>

            <div class="col-12 col-sm-6">
              <p class="text-muted q-mb-xs">ABN:</p>
              <p class="q-mb-none">{{ user.company.abn }}</p>
            </div>
          </div>
        </div>
      </q-card-section>

      <q-card-section tag="section">
        <h6>Business Details:</h6>

        <div class="bg-gray q-pa-md">
          <div class="row q-col-gutter-sm">
            <div class="col-12 col-sm-6">
              <p class="text-muted q-mb-xs">Business Name:</p>
              <p class="text-capitalize">{{ user.businessName }}</p>
            </div>

            <div class="col-12 col-sm-6">
              <template v-if="isTransporter">
                <p class="text-muted q-mb-xs">Trading Name:</p>
                <p class="text-uppercase">{{ user.company.tradingName }}</p>
              </template>

              <template v-else>
                <p class="text-muted q-mb-xs">Contact Person:</p>
                <p class="text-capitalize">{{ user.name }}</p>
              </template>
            </div>

            <div class="col-12 col-sm-6">
              <template v-if="isTransporter">
                <p class="text-muted q-mb-xs">Main office phone number</p>
                <p>{{ user.company.mainOfficePhone }}</p>
              </template>

              <template v-else>
                <p class="text-muted q-mb-xs">Phone Number:</p>
                <p>{{ user.phone }}</p>
              </template>
            </div>

            <div class="col-12 col-sm-6">
              <p class="text-muted q-mb-xs">Email:</p>
              <p>{{ user.email }}</p>
            </div>

            <div class="col-12 col-sm-6">
              <p class="text-muted q-mb-xs">Company Address:</p>

              <template v-if="isTransporter">
                <p v-for="(address, idx) in user.company.companyAddress" :key="idx" class="q-mb-xs">
                  {{ address }}
                </p>
              </template>

              <template v-else>
                <p v-if="!user.profile.companyAddress">(Empty)</p>

                <p v-for="(address, idx) in user.profile.companyAddress" v-else :key="idx" class="q-mb-xs">
                  {{ address }}
                </p>
              </template>
            </div>

            <div class="col-12 col-sm-6">
              <p class="text-muted q-mb-xs">
                <template v-if="isTransporter">Operational Address:</template>
                <template v-else>Delivery Address: </template>
              </p>

              <template v-if="isTransporter">
                <p v-for="(address, idx) in user.company.operationalAddress" :key="idx" class="q-mb-xs">
                  {{ address }}
                </p>
              </template>

              <template v-else>
                <p v-if="!user.profile.deliveryAddress">(Empty)</p>

                <p v-for="(address, idx) in user.profile.deliveryAddress" v-else :key="idx" class="q-mb-xs">
                  {{ address }}
                </p>
              </template>
            </div>
          </div>
        </div>
      </q-card-section>

      <q-card-section v-if="isTransporter" tag="section">
        <h6>Company Representative:</h6>

        <div class="bg-gray q-pa-md">
          <div class="row q-col-gutter-sm">
            <div class="col-12 col-sm-6">
              <p class="text-muted q-mb-xs">First Name:</p>
              <p class="text-capitalize">{{ user.company.repFirstName }}</p>
            </div>

            <div class="col-12 col-sm-6">
              <p class="text-muted q-mb-xs">Last Name:</p>
              <p class="text-capitalize">{{ user.company.repLastName }}</p>
            </div>

            <div class="col-12 col-sm-6">
              <p class="text-muted q-mb-xs">Telephone Number:</p>
              <p class="text-capitalize q-mb-none">{{ user.company.repPhone }}</p>
            </div>

            <div class="col-12 col-sm-6">
              <p class="text-muted q-mb-xs">Position:</p>
              <p class="text-capitalize q-mb-none">{{ user.company.repPosition }}</p>
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { getSourceFromAsset } from '@/utils';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    openSync: {
      get() {
        return this.open;
      },

      set(val) {
        return this.$emit('update:open', val);
      },
    },

    isTransporter() {
      return this.user.type === 'transporter';
    },

    userPhoto() {
      if (this.user.company?.companyLogo) {
        return this.user.company.companyLogo;
      }

      if (this.user.profile?.companyLogo) {
        return this.user.profile.companyLogo;
      }

      return getSourceFromAsset('icon_Personal.png');
    },
  },
};
</script>
